/** Per-user locale selector — Phase 3-i18n.
 *
 * A compact globe-icon dropdown matching the marketing site's header
 * switcher. Used in the TopBar, the partner/platform bars, and the auth
 * pages. The chosen locale persists to localStorage (see `lib/i18n/index.ts`)
 * so the choice survives reload; the SPA also honours a `?lang=` param
 * carried over from the marketing site.
 */
import { useTranslation } from "react-i18next";

import { SUPPORTED_LOCALES } from "@/lib/i18n";


export function LocaleSwitcher() {
  const { i18n, t } = useTranslation();

  return (
    <div className="relative inline-flex items-center">
      {/* globe glyph */}
      <svg
        aria-hidden
        viewBox="0 0 24 24"
        fill="none"
        className="pointer-events-none absolute left-2 h-3.5 w-3.5 text-nb-text-2"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M3 12 H21 M12 3 C 14.5 6 14.5 18 12 21 M12 3 C 9.5 6 9.5 18 12 21"
          stroke="currentColor"
          strokeWidth="1.6"
        />
      </svg>
      <span className="sr-only">{t("common.language")}</span>
      <select
        className="appearance-none rounded-md border border-nb-border bg-slate-900 py-1 pl-7 pr-6 text-xs text-nb-text hover:border-nb-mint/60 focus:border-nb-mint focus:outline-none"
        value={i18n.resolvedLanguage || "en"}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value);
        }}
        data-testid="locale-switcher"
        aria-label={t("common.language")}
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
      {/* chevron */}
      <svg
        aria-hidden
        viewBox="0 0 24 24"
        fill="none"
        className="pointer-events-none absolute right-1.5 h-3 w-3 text-nb-text-3"
      >
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
